import { createContext, useContext, useEffect, useState } from "react";

const I18nContext = createContext(null);

const dict = {
  fr: {
    "nav.home": "Accueil",
    "nav.universe.street_food": "Street Food",
    "nav.universe.street_market": "Street Market",
    "nav.universe.food_truck": "Food Truck",
    "nav.about": "Notre Histoire",
    "nav.magazine": "Magazine",
    "nav.recipes": "Recettes",
    "nav.catering": "Traiteur",
    "nav.contact": "Contact",
    "nav.faq": "FAQ",
    "nav.account": "Mon compte",
    "nav.login": "Se connecter",
    "nav.register": "Créer un compte",
    "nav.logout": "Déconnexion",
    "nav.cart": "Panier",
    "common.discover": "Découvrir",
    "common.see_all": "Tout voir",
    "common.read_more": "Lire la suite",
    "common.book_now": "Réserver",
    "common.send": "Envoyer",
    "common.email": "Email",
    "common.password": "Mot de passe",
    "common.name": "Nom complet",
    "common.phone": "Téléphone",
    "common.subject": "Sujet",
    "common.message": "Message",
    "common.required": "Champ requis",
    "common.submit": "Envoyer",
    "common.loading": "Chargement…",
    "hero.eyebrow": "Maison Dakar — Sénégal · Depuis 2026",
    "hero.title": "Le goût authentique de Dakar",
    "hero.subtitle": "Une maison, trois univers. La street food sénégalaise comme vous ne l'avez jamais vécue.",
    "hero.cta": "Découvrir nos univers",
    "hero.cta_secondary": "Voir le Food Truck",
    "trust.delivery.title": "Livraison express",
    "trust.delivery.desc": "Livraison à domicile · 25-45 min",
    "trust.payment.title": "Paiement sécurisé",
    "trust.payment.desc": "Visa, Mastercard, PayPal & 3x sans frais",
    "trust.collect.title": "Ramassage en boutique",
    "trust.collect.desc": "Commandez, retirez chaud en 15 min",
    "universes.eyebrow": "Une maison · Trois univers",
    "universes.title": "Explorez les saveurs de Dakar à votre façon",
    "featured.eyebrow": "Sélection du Chef",
    "featured.title": "Les indispensables",
    "team.eyebrow": "Notre équipe",
    "team.title": "Des artisans, pas des cuisiniers",
    "team.subtitle": "Six talents passionnés réunis autour d'une vision commune : faire rayonner la cuisine sénégalaise au plus haut niveau.",
    "testimonials.eyebrow": "Ils nous font confiance",
    "testimonials.title": "La parole de nos clients",
    "magazine.eyebrow": "Le Magazine",
    "magazine.title": "Histoires, terroirs et inspirations",
    "magazine.subtitle": "Plongez dans l'univers de la cuisine sénégalaise à travers nos reportages, portraits et carnets de voyage.",
    "newsletter.title": "Rejoignez la maison",
    "newsletter.subtitle": "Recevez nos nouvelles recettes, événements et offres exclusives. -10% offerts dès l'inscription.",
    "newsletter.placeholder": "Votre email",
    "newsletter.cta": "M'inscrire",
    "newsletter.success": "Bienvenue dans la famille",
    "footer.tagline": "Une maison, trois univers. Le goût authentique de Dakar livré à votre table, depuis 2026.",
    "footer.universes": "Univers",
    "footer.maison": "Maison",
    "footer.contact": "Contact",
    "footer.legal": "Mentions légales",
    "footer.cgv": "CGV",
    "footer.privacy": "Confidentialité",
    "auth.login.title": "Bon retour parmi nous",
    "auth.login.subtitle": "Accédez à vos commandes, favoris et adresses.",
    "auth.login.cta": "Se connecter",
    "auth.login.no_account": "Pas encore de compte ?",
    "auth.register.title": "Rejoignez la maison",
    "auth.register.subtitle": "Créez votre compte pour commander, suivre vos livraisons et profiter d'offres exclusives.",
    "auth.register.cta": "Créer mon compte",
    "auth.register.has_account": "Déjà un compte ?",
    "about.eyebrow": "Notre histoire",
    "about.title": "Une maison née de la passion",
    "contact.title": "Contactez-nous",
    "contact.subtitle": "Une question, une demande spéciale, un projet ? L'équipe vous répond sous 24h.",
    "catering.eyebrow": "Traiteur & Événementiel",
    "catering.title": "L'excellence sénégalaise pour vos événements",
    "catering.subtitle": "Mariages, séminaires d'entreprise, anniversaires : nous vous offrons une expérience culinaire inoubliable, sur mesure.",
  },
  en: {
    "nav.home": "Home",
    "nav.universe.street_food": "Street Food",
    "nav.universe.street_market": "Street Market",
    "nav.universe.food_truck": "Food Truck",
    "nav.about": "Our Story",
    "nav.magazine": "Magazine",
    "nav.recipes": "Recipes",
    "nav.catering": "Catering",
    "nav.contact": "Contact",
    "nav.faq": "FAQ",
    "nav.account": "Account",
    "nav.login": "Sign in",
    "nav.register": "Create account",
    "nav.logout": "Sign out",
    "nav.cart": "Cart",
    "common.discover": "Discover",
    "common.see_all": "See all",
    "common.read_more": "Read more",
    "common.book_now": "Book",
    "common.send": "Send",
    "common.email": "Email",
    "common.password": "Password",
    "common.name": "Full name",
    "common.phone": "Phone",
    "common.subject": "Subject",
    "common.message": "Message",
    "common.required": "Required field",
    "common.submit": "Submit",
    "common.loading": "Loading…",
    "hero.eyebrow": "Maison Dakar — Senegal · Est. 2026",
    "hero.title": "The authentic taste of Dakar",
    "hero.subtitle": "One house, three worlds. Senegalese street food like you've never experienced it.",
    "hero.cta": "Explore our worlds",
    "hero.cta_secondary": "Visit the Food Truck",
    "trust.delivery.title": "Express delivery",
    "trust.delivery.desc": "Home delivery · 25-45 min",
    "trust.payment.title": "Secure payment",
    "trust.payment.desc": "Visa, Mastercard, PayPal & 3x interest-free",
    "trust.collect.title": "Pickup in-store",
    "trust.collect.desc": "Order online, pick up hot in 15 min",
    "universes.eyebrow": "One house · Three worlds",
    "universes.title": "Explore the flavors of Dakar your way",
    "featured.eyebrow": "Chef's Selection",
    "featured.title": "The essentials",
    "team.eyebrow": "Our team",
    "team.title": "Artisans, not just cooks",
    "team.subtitle": "Six passionate talents united around a common vision: showcasing Senegalese cuisine at the highest level.",
    "testimonials.eyebrow": "They trust us",
    "testimonials.title": "What our clients say",
    "magazine.eyebrow": "The Magazine",
    "magazine.title": "Stories, terroirs and inspirations",
    "magazine.subtitle": "Dive into the world of Senegalese cuisine through our reports, portraits and travel diaries.",
    "newsletter.title": "Join the house",
    "newsletter.subtitle": "Get new recipes, events and exclusive offers. -10% on your first order when you subscribe.",
    "newsletter.placeholder": "Your email",
    "newsletter.cta": "Subscribe",
    "newsletter.success": "Welcome to the family",
    "footer.tagline": "One house, three worlds. The authentic taste of Dakar delivered to your table, since 2026.",
    "footer.universes": "Worlds",
    "footer.maison": "House",
    "footer.contact": "Contact",
    "footer.legal": "Legal notice",
    "footer.cgv": "Terms",
    "footer.privacy": "Privacy",
    "auth.login.title": "Welcome back",
    "auth.login.subtitle": "Access your orders, favorites and addresses.",
    "auth.login.cta": "Sign in",
    "auth.login.no_account": "No account yet?",
    "auth.register.title": "Join the house",
    "auth.register.subtitle": "Create your account to order, track deliveries and enjoy exclusive offers.",
    "auth.register.cta": "Create my account",
    "auth.register.has_account": "Already have an account?",
    "about.eyebrow": "Our story",
    "about.title": "A house born of passion",
    "contact.title": "Get in touch",
    "contact.subtitle": "A question, a special request, a project? Our team replies within 24h.",
    "catering.eyebrow": "Catering & Events",
    "catering.title": "Senegalese excellence for your events",
    "catering.subtitle": "Weddings, corporate seminars, birthdays: we offer an unforgettable, tailor-made culinary experience.",
  },
};

export const I18nProvider = ({ children }) => {
  const [lang, setLang] = useState("en");  // Locked to English per business decision
  useEffect(() => {
    localStorage.setItem("dsf_lang", "en");
    document.documentElement.lang = "en";
  }, [lang]);

  const t = (key) => dict[lang][key] || dict.en[key] || key;
  return <I18nContext.Provider value={{ lang, setLang, t }}>{children}</I18nContext.Provider>;
};

export const useI18n = () => {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used inside I18nProvider");
  return ctx;
};
